import React, { useEffect } from 'react';

// This component was created as a workaround to address accessibility bugs in fluentUI components.
// Note this was custom built based on the rendered DOM for the existing version of fluentUI, do 
// not use this component in genral to modify non-ant components, as it won't work.
const AccessibleDetailsList = (props: any): any => {
    useEffect(() => {
        const elementId = props?.id;
        if (!elementId) {
            return;
        }

        let elems = document.querySelectorAll("div[class^='ms-DetailsHeader-cellSizer'], div[class*=' ms-DetailsHeader-cellSizer]");
        elems.forEach((el) => {
            el?.parentElement?.removeChild(el);
        })
    });
    let Component = props?.component;
    return <Component {...props} />
}

export default AccessibleDetailsList;